// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"447":"bb2ead5e","672":"a7d0081b"}[chunkId] + ".css";
};